import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';
import Header from './Header';

const Contact = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:itarnaevents2@gmail.com?subject=Contact from Croqly Website&body=Hello,%0D%0A%0D%0AI would like to get in touch regarding...';
  };

  return (
    <div>
      {/* Floating background elements */}
      <div className="floating-elements">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      <Header />

      <div className="container">
        <div className="page-header">
          <div className="app-icon">
            <img src="croqly-logo.jpeg" alt="Croqly App Icon" />
          </div>
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">Croqly – Crochet & Knitting Companion</p>
          <div className="last-updated">Get in touch with our team</div>
        </div>

        <main className="content">
          <div className="contact-intro">
            <h2>We'd Love to Hear From You!</h2>
            <p>Have questions about Croqly? Need help with your crochet projects? Want to share feedback or suggestions? We're here to help and would love to connect with our amazing community of crafters.</p>
          </div>

          <div className="contact-methods">
            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </div>
              <h3>Email Us</h3>
              <p>Send us an email and we'll get back to you within 24 hours.</p>
              <button onClick={handleEmailClick} className="email-button">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                itarnaevents2@gmail.com
              </button>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3>Quick Response</h3>
              <p>We typically respond to all inquiries within 24 hours during business days.</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3>Community Support</h3>
              <p>Join our community of passionate crocheters and knitters for tips, inspiration, and support.</p>
            </div>
          </div>

          <div className="contact-info">
            <h2>What Can We Help You With?</h2>
            <div className="help-topics">
              <div className="topic-item">
                <h4>📱 App Support</h4>
                <p>Technical issues, bug reports, or feature requests</p>
              </div>
              <div className="topic-item">
                <h4>🧶 Crochet Help</h4>
                <p>Pattern questions, technique guidance, or project advice</p>
              </div>
              <div className="topic-item">
                <h4>💡 Feature Ideas</h4>
                <p>Suggestions for new features or improvements</p>
              </div>
              <div className="topic-item">
                <h4>🤝 Partnerships</h4>
                <p>Collaboration opportunities or business inquiries</p>
              </div>
            </div>
          </div>

        </main>
      </div>

      <footer>
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div>
              <p>&copy; 2025 Croqly. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
